import Overview from './overview.vue';
import Detail from '@rebuild/materials/shared/news/DetailIndex.vue';
import MobFull from '@rebuild/materials/shared/news/mobile/FullIndex.vue';
import MobDetail from '@rebuild/materials/shared/news/mobile/DetailIndex.vue';

export const componentMap = {
	overview: Overview,
	detail: Detail,
	'mob-full': MobFull,
	'mob-detail': MobDetail
}; 